import { PlatformsAuthEvent, PlatformsAuthSignupErrorEvent } from '~/types';

export function isAuthServiceSSOSignupError(
  evnt: PlatformsAuthEvent
): evnt is PlatformsAuthSignupErrorEvent {
  return (
    evnt.type === 'authservice-sso-foam-signup-error' ||
    evnt.type === 'authservice-sso-echo-signup-error'
  );
}
